package com.klantenstop.web.pages.authentication.registration

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.form.RegisterForm
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.navigation.unauthenticatedGuard
import com.klantenstop.web.pages.authentication.components.AuthenticationContainer
import com.klantenstop.web.utils.Res
import com.klantenstop.web.utils.decodeReturnUrl
import com.klantenstop.web.utils.format
import com.materialkobweb.utils.rememberViewModel
import com.materialkobweb.components.DsPageLayout
import com.materialkobweb.components.widgets.FilledButton
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.navigation.Link
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

@Page("/registreren")
@Composable
fun RegisterPage() = unauthenticatedGuard {
    val pageContext = rememberPageContext()

    // Use constant key to maintain ViewModel across navigation
    val viewModel = rememberViewModel(cached = false) { RegistrationViewModel() }
    val state by viewModel.state.collectAsState()

    // Get the terugNaar query parameter and decode from base64
    val returnTo = pageContext.route.params["terugNaar"]?.let { encodedUrl ->
        decodeReturnUrl(encodedUrl)
    } ?: Navigation.Screen.Home.route

    LaunchedEffect(Unit) {
        viewModel.effect.collect { event ->
            when (event) {
                RegistrationContract.Effect.NavigateToNextScreen -> {
                    pageContext.router.navigateTo(
                        pathQueryAndFragment = returnTo,
                        updateHistoryMode = UpdateHistoryMode.REPLACE
                    )
                }
            }
        }
    }

    RegistrationPageContent(
        returnTo = returnTo,
        state = state,
        sendIntent = viewModel::sendIntent
    )
}

@Composable
private fun RegistrationPageContent(
    returnTo: String?,
    state: RegistrationContract.State,
    sendIntent: (RegistrationContract.Intent) -> Unit
) {
    DsPageLayout(
        modifier = Modifier.fillMaxSize(),
        title = Res.String.DocumentTitle.format("Registreren"),
        header = {},
        overflowMenu = {},
        overflowMenuOpened = false,
        footer = {},
        sidePanel = {},
    ) {
        AuthenticationContainer(
            title = "Registreer",
            content = {
                RegisterForm(
                    validateFields = state.showValidation,
                    onFormDataChanged = { sendIntent(RegistrationContract.Intent.UpdateFormData(it)) },
                    onCommit = { sendIntent(RegistrationContract.Intent.Registration) }
                )

                FilledButton(
                    modifier = Modifier.fillMaxWidth(),
                    type = ButtonType.Submit,
                    onClick = {
                        sendIntent(RegistrationContract.Intent.Registration)
                    }
                ) {
                    Text("Registreer")
                }
            },
            footer = {
                Text("Ben je al bekend bij ons? ")
                Link(
                    modifier = authLinkModifier,
                    path = Navigation.Screen.Login(returnTo).route,
                    updateHistoryMode = UpdateHistoryMode.REPLACE,
                    text = "Log dan in"
                )
                // TODO: not possible for now, but maybe in the future we want to allow users to create an account for their company without having to create a personal account first.
                //  In that case we can add this link back and create a separate registration page for companies.
//                Text(" of wil je in naam je ")
//                Link(
//                    modifier = authLinkModifier,
//                    path = Navigation.Screen.RegisterCompany.route,
//                    updateHistoryMode = UpdateHistoryMode.REPLACE,
//                    text = "bedrijf een account aanmaken?"
//                )
            })
    }
}

// TODO: Replace with a proper style solution
val authLinkModifier = Modifier
    .fontWeight(FontWeight.Bold)
    .textDecorationLine(TextDecorationLine.Underline)
    .onMouseOver {
        (it.currentTarget as? HTMLElement)?.style?.textDecorationLine = TextDecorationLine.None.toString()
    }
    .onMouseLeave {
        (it.currentTarget as? HTMLElement)?.style?.textDecorationLine = TextDecorationLine.Underline.toString()
    }



